import Logo from '../images/Logo.svg';
import { FaTimes } from 'react-icons/fa';
import Hamburger from '../images/Hamburger.svg';
import React, { useState } from 'react';
import './Header.scss'; 

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (

  <header className="header">
    <a href='/' className='logo'><img src={Logo} alt="Kshiti logo"/></a>
    
      <nav className={`nav ${menuOpen ? 'nav-open' : ''}`}>
        <a href="/about">About</a>
        <a href="/portfolio">Portfolio</a>
        <a href="/artstudio">Art Studio</a>
        <a href="https://medium.com/@kshitighelani" target='_blank'>Blog</a>
        <a href="/contact">Contact</a>
      </nav>

      <div className="menu-icon" onClick={toggleMenu}>
    {menuOpen ? <FaTimes className='nav-close-icon' /> : <img src={Hamburger} alt="Menu Icon" className="hamburger-icon"/>}
      </div>
  </header>
  );
};

export default Header;